import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ac485f72408c28adf028cfafdb15946fab from "./generated-1bd72cd2-2138-4491-9323-a9b219592da8.json";

import adcb996b1a24a7bcb3ce66d9d77fd0913b from "./generated-b7531fa6-13ae-4af9-aeb0-a616ee33cbe6.json";

import a842eee6994c6ec5bcf367fbb6e3e3933b from "./generated-4b366a55-fff7-4728-9c7f-594342e3b282.json";

import ab4e74633966f91d78fae69d5361fa2b0b from "./generated-8fd6a312-4235-4dc5-be0b-a3a4ff9aa16d.json";

import a8dc0ad1dda04e3245f2879593712049db from "./generated-94453aeb-3df3-4ffb-9f40-83c5b579dacc.json";

import ac5e3a9dd9e50a43a9a44d2ff6d285899b from "./generated-cd78b732-7bb6-4be0-8161-77e4236ef5fe.json";

import a7265c522be7108d03c73ab53eec3f220b from "./generated-d886e999-ff08-40da-9f97-b5b3389d175e.json";

import a8fbb5ed58b9c180af8ecb7c7b46669b5b from "./generated-dc943381-46cc-4537-a383-06068cc1decf.json";

import aacf8c48c5b2edb82d0acbf75d6c0ee48b from "./generated-6bd747e6-5c30-463d-82a9-64a9452836f5.json";

import ad423e0b0b70374c2e6bf6c04292c13d0b from "./generated-a46fda34-931e-4f6f-9585-67bd5134819a.json";

import a8c6be504e76316906ed973e6fcf009e5b from "./generated-71753735-7b21-461b-9d47-aa9909adda73.json";

import a4a1a4a4a93a2d07db4007bf7acfa7231b from "./generated-078cf738-1556-4969-b471-5742f74f751d.json";

import aa9ab94733af76ece96d208cca593891cb from "./generated-093c3724-e86d-411b-a0e2-20fb166bd89e.json";

import aa583a00679014fcd0685cd3c9c30e143b from "./generated-1e2752c0-cd28-46db-b175-97e4f7580058.json";

import aa0e947fa3f1f9a8a79e6086df82298aeb from "./generated-11552ddd-c0fb-4ea9-9cea-4038ed493d51.json";

import a4c874d2f784455b8f5823ad940b5c8f6b from "./generated-d50bc14d-5e80-4452-92de-95ba143411d6.json";

import ac98a3559763aa25693e82da7c5dfe583b from "./generated-9e7f51cc-8c3d-44c0-a682-cef66f74666b.json";

import ae9c3565961f687d9ce82c3de9c5fff04b from "./generated-ceaa1eb4-3dc3-423c-9230-ade6c25f35ed.json";

import aafe75dc81d2750408241c0f642998e7cb from "./generated-c99a5b3e-7d8a-4f32-91ec-1f9fb4e65296.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ac485f72408c28adf028cfafdb15946fab);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(adcb996b1a24a7bcb3ce66d9d77fd0913b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a842eee6994c6ec5bcf367fbb6e3e3933b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ab4e74633966f91d78fae69d5361fa2b0b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a8dc0ad1dda04e3245f2879593712049db);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(ac5e3a9dd9e50a43a9a44d2ff6d285899b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a7265c522be7108d03c73ab53eec3f220b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a8fbb5ed58b9c180af8ecb7c7b46669b5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(aacf8c48c5b2edb82d0acbf75d6c0ee48b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ad423e0b0b70374c2e6bf6c04292c13d0b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a8c6be504e76316906ed973e6fcf009e5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a4a1a4a4a93a2d07db4007bf7acfa7231b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(aa9ab94733af76ece96d208cca593891cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(aa583a00679014fcd0685cd3c9c30e143b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(aa0e947fa3f1f9a8a79e6086df82298aeb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a4c874d2f784455b8f5823ad940b5c8f6b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ac98a3559763aa25693e82da7c5dfe583b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ae9c3565961f687d9ce82c3de9c5fff04b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(aafe75dc81d2750408241c0f642998e7cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ac98a3559763aa25693e82da7c5dfe583b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */